<script>
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';

  export default {
  name: 'VerbalDiscussionEnded',
  computed: {
    ...mapGetters([
      'hasTeacherPermissionsInCourse',
      'getCurrentDiscussion'
    ]),

    hasStudents() {
      const discussion = this.getCurrentDiscussion;
      return discussion && discussion.participations && discussion.participations.length > 0;
    },
  },
  methods: {
    handleChangeTab: function(tab) {
      EventBus.$emit('handleTab', tab);
    },
    handleRestartDiscussion: async function() {
      try {
        await this.$store.dispatch('restartLiveDiscussion', this.getCurrentDiscussion.id);
        EventBus.$emit('restartLD');
      } catch (err) {
        EventBus.$emit('createToast', { type: 'Error', message: 'Could not restart the discussion', time: 5000 });
      }
    },
    handleStartVerbal: async function() {
      if (!this.getCurrentDiscussion) return;

      if (this.getCurrentDiscussion.is_ended) {
        await this.handleRestartDiscussion();
      } else {
        if (!this.hasStudents) {
          EventBus.$emit('createToast', { type: 'Info', message: 'You need to invite students before starting the discussion', time: 5000 });
          return;
        }

        EventBus.$emit('handleOpenStartDiscussionModal');
      }
    }
  }
};
</script>

<template>
  <div class="flex flex-col justify-center items-center relative w-full max-w-2xl">
    <div class="h-12 w-12 rounded-full bg-white border border-red-500 flex items-center justify-center">
      <i class="fa-solid fa-stop text-red-500"></i>
    </div>
    <div class="px-2 pt-6 pb-6 text-center">
      <h2 class="font-poppins text-xl font-semibold text-gray-900">The RoundTable has stopped</h2>
      <p v-if="hasTeacherPermissionsInCourse" class="mt-2 text-sm leading-6 text-gray-700">
        Restart to continue the discussion or review the class summary.
      </p>
      <p v-else class="mt-4 text-sm text-slate-600">
        Thanks for participating! Take a moment to review the class summary and reflect on your contributions.
      </p>
      <div class="mt-6 flex flex-col sm:flex-row items-center justify-center gap-2">
        <button
          type="button"
          v-if="hasTeacherPermissionsInCourse"
          @click="handleStartVerbal()"
          class="w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-green-700 text-white text-sm font-medium hover:bg-green-800 "
          aria-label="Restart the discussion"
        >
          Start discussion
        </button>
        <button
          type="button"
          @click="handleChangeTab('summary')"
          class="w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-full hover:bg-gray-200 text-gray-800 text-sm font-medium border border-gray-200 bg-gray-100"
          aria-label="View the class summary"
        >
          View class summary
        </button>
      </div>
      
    </div>
  </div>
</template>


// WEBPACK FOOTER //
// VerbalDiscussionEnded.vue?ef527abe